<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">投诉BU：</div>
            <div class="item-text">{{ data.pub_bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">投诉理由：</div>
            <div class="item-text">{{ data.complain_reason }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">被投诉BU：</div>
            <div class="item-text">{{ data.sub_bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">拒绝理由：</div>
            <div class="item-text">{{  data.reject_reason }}</div>
        </div>

         <div class="form-item" v-show="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result }}</div>
        </div>
        
        <!-- <sliderHistoty :data="data.cancel" :listdata="logList"></sliderHistoty> -->

        <!-- 审核 -->
        <div v-if="data.status==1 && $route.name!='my-application'"  v-form:apply-complain>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

    </div>
</template>

<script>
    // import sliderHistoty from "src/components/slider/slider_history.vue"
    // import { getAllTemp } from 'src/control/common.js';  //公共方法
    // import { mapGetters,mapState } from "vuex"

    export default {
        props:["sliderArg","data","resub","examine"],
        components:{
            // sliderHistoty,
        },
        data(){
            return {

            }
        },
        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("budget-again");
                    this.$form.clear("apply-complain");
                }
            },
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-complain");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
            },
            checkNotPass(){
                let res = this.$form.check("apply-complain");
                if(!res){
                    return;
                }

                this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// slider_complainTask.vue?66413e4c